import { TrickModes } from '@smart-tv/components/player/types';

export const disableFastForwardCatchup = (trickmodes?: number): boolean => {
  if (!trickmodes) return true;

  return (trickmodes & TrickModes.CatchupAllowFastforward) === 0;
};

export default disableFastForwardCatchup;
